/**
 * @hidden
 */
var Container = function (props) { return (props.children); };
Container.displayName = 'Container';
// tslint:disable:max-line-length
/**
 * To provide support for React versions which do not support `React.Fragment`, the following component acts as its replacement. Returning an array is not an option as it blocks unit testing until [https://github.com/airbnb/enzyme/pull/1498#issuecomment-378413134](https://github.com/airbnb/enzyme/pull/1498#issuecomment-378413134) is released.
 */
export { Container };
//# sourceMappingURL=Container.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-charts/dist/es/Container.js
// module id = 2452
// module chunks = 29